import React from "react";
function ClientHeader(){
     return(
           <div className="staffs">
                <h5 className="h5">What our clients are saying</h5>
                <p className="pap">Our clients our voice</p>

           </div>
     )
}
export default ClientHeader;